import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-12 pb-16 md:pt-32 md:pb-32 overflow-hidden bg-mint" data-id="element-153">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-154">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-sage/10 blur-3xl" data-id="element-155"></div>
        <div className="absolute bottom-[10%] -left-[10%] w-[40%] h-[40%] rounded-full bg-gold/10 blur-3xl" data-id="element-156"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 max-w-6xl" data-id="element-157">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-20" data-id="element-158">
          <div className="flex-1 text-center lg:text-left" data-id="element-159">
            <FadeIn data-id="element-160">
              <span className="inline-block py-1 px-3 rounded-full bg-sage/20 text-forest font-semibold text-xs md:text-sm tracking-wider mb-3 md:mb-6 uppercase" data-id="element-161">
                Bienestar Digestivo
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-162">
              <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold leading-tight mb-3 md:mb-6" data-id="element-163">
                PROTOCOLO SOS 72H: <br className="hidden md:block" data-id="element-164" />
                <span className="text-sage italic font-light" data-id="element-165">
                  El Interruptor que Apaga tu Inflamación Abdominal
                </span>{' '}
                en 3 Días Exactos
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-166">
              <p className="text-sm md:text-xl text-gray-700 mb-5 md:mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-167">
                Deja de pelearte con tu ropa y recupera tu energía digestiva
                utilizando el Método de Eliminación Selectiva, sin pasar hambre
                ni gastar en suplementos caros.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-168">
              <Button variant="scroll" data-id="element-169" />
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-xs md:max-w-sm lg:max-w-md relative" data-id="element-170">
            <FadeIn delay={0.4} direction="left" data-id="element-171">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform lg:-rotate-2 transition-transform hover:rotate-0 duration-500" data-id="element-172">
                <img src="https://cdn.magicpatterns.com/uploads/kxzMxXAmgQv1NttwpamgJT/heylloyd-image-1775063615406.png" alt="Portada del libro Protocolo SOS 72H" className="w-full h-auto object-cover" data-id="element-173" />
                <div className="absolute inset-0 bg-gradient-to-t from-forest/20 to-transparent pointer-events-none" data-id="element-174"></div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}